import {applyMiddleware, combineReducers, createStore, Store} from 'redux';

import messages from './message-box/message-box-reducer';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import {searchReducer} from './search/duck/search-reducer';
import {settingsReducer} from './settings/duck/settings-reducer';
import {configReducer} from './config/config-reducer';
import {backendTranslationsReducer} from './backendTranslations/backendTranslations-reducer';
import {facetFilterReducer} from './facets/duck/facet-filter-reducer';

export const createFullStore = (): Store => {
    const appReducer = combineReducers({
        messages,
        search: searchReducer,
        settings: settingsReducer,
        config: configReducer,
        translations: backendTranslationsReducer,
        facetFilter: facetFilterReducer
    });

    const rootReducer = (state, action) => {
        return appReducer(state, action);
    };

    const storeEnhancer = composeWithDevTools({trace: true, traceLimit: 25})(applyMiddleware(thunk));
    return createStore(rootReducer, storeEnhancer);
};

export const store = createFullStore();
